import React from 'react';
import { useSelector } from 'react-redux';
import T from 'prop-types';
import { times } from 'lodash-es';
import cx from 'classnames';

import { AiTabNavigationDropdown } from './AiTabNavigation';
import AppIcon from '../../../components/AppIcon';
import Skeleton from '../../../components/Skeleton';
import Container from '../../../components/Container';
import { scrollToSection } from '../hooks/useAiDashboardNav';
import { aiDashboardAppsSelector } from '../selectors';

const AiStickyHeader = ({ active, isSticky, showTopApps }) => {
  const apps = useSelector(aiDashboardAppsSelector);

  const visibleApps = (showTopApps ? apps.data?.top_apps : apps.data?.apps) || [];

  return (
    <div className="ai-sticky-header__outer">
      <div className={cx('ai-sticky-header', { 'ai-sticky-header--visible': isSticky })}>
        <Container maxWidth={1128}>
          <div className="ai-sticky-header__content">
            <div className="ai-sticky-header__left">
              <span className="eyebrow">Gen AI App Insights</span>
              <AiTabNavigationDropdown active={active} onScrollToSection={scrollToSection} />
            </div>
            <div key={showTopApps ? 'top' : 'all'} className="ai-sticky-header__apps">
              {apps.settings.pending
                ? times(5).map((i) => <Skeleton key={i} height={32} width={32} />)
                : visibleApps.map((app) => (
                    <AppIcon
                      key={app.ref_no}
                      url={app.icon_url}
                      store={app.store}
                      size={32}
                      alt={app.nickname}
                      withBorder
                    />
                  ))}
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

AiStickyHeader.propTypes = {
  active: T.object.isRequired,
  isSticky: T.bool.isRequired,
  showTopApps: T.bool.isRequired,
};

export default AiStickyHeader;
